module.exports = __webpack_public_path__ + "static/media/8-2.23899ad1.mp3";